<template>
  <div id="iv-footInfo">
    <div v-if="showInfo" style="height: 48px;">
      <div
        ref="bottomMask"
        class="iv-home-fixed"
        :class="{'iv-fixed-bottom': isBottom}">
        <div class="iv-home-tip iv-fs-16">
          <IconFont type="play-circle"></IconFont>
          <span class="iv-m-l-8 iv-home-tip-title uit-infor" @click="jumpDetail">{{courseName}}</span>
          <span class="iv-home-tip-study uit-continue" @click="continueLearn">继续学习</span>
          <IconFont type="close" class="iv-pull-right iv-home-tip-close uit-close-info" @click="closeInfo"></IconFont>
        </div>
      </div>
    </div>
    <div ref="Footer" class="iv-footer iv-fc-45 iv-fs-14">
      <div class="iv-footer-content">
        <div class="iv-footer-left iv-pull-left">
          <span>{{companyInfo}}</span>
        </div>
        <div class="iv-footer-right iv-pull-right">
          <ul class="iv-fc-65">
            <li class="uit-weixin-li">
              <Poptip trigger="hover" popper-class="iv-pop-width">
                <span>微信公众号</span>
                <div slot="title">微信公众号</div>
                <div slot="content">
                  <img src="../../static/images/login.png" alt="" />
                </div>
              </Poptip>
            </li>
            <li class="uit-app-li" @click="downApp">APP下载</li>
            <li class="uit-help-lii" @click="helpCenter">帮助中心</li>
            <li class="uit-we-li" @click="aboutWe">关于我们</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Poptip } from 'iview'
import IconFont from '@/components/iconfont'
import playMixin from '@/mixins/play'
export default {
  mixins: [playMixin],
  data () {
    return {
      companyInfo: '版权由中国进出口银行拥有 Copyright@2014 京ICP备09083915号',
      fixStyle: {
        'bottom': 0
      },
      showInfo: false,
      courseID: '',
      courseName: '',
      isBottom: true
    }
  },
  watch: {
    showInfo (newVal, oldVal) {
      let tipDom = document.querySelector('.iv-home-ranking')
      if (!this.showInfo) {
        if (tipDom) {
          tipDom.style.marginBottom = '0'
        }
      }
    },
    '$route' () {
      if (this.$route.name == 'index') {
        window.scrollTo(0, 0)
        this.showInfo = true
        this.getVideoInfo()
      } else {
        this.showInfo = false
      }
    }
  },
  created () {
    if (this.$route.name == 'index') {
      this.showInfo = true
      this.getVideoInfo()
    } else {
      this.showInfo = false
    }
    window.onscroll = null
  },
  methods: {
    getPosition (footerDom) {
      let scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop
      if (scrollY >= this.total) {
        this.isBottom = false
        return
      }
      this.isBottom = true
    },
    initBottomScroll () {
      let scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop
      let height = (document.documentElement || document.body).offsetHeight
      let footerTop = this.$refs.Footer.getBoundingClientRect().top
      this.total = (scrollY + footerTop - height)
      this.getPosition()
    },
    initScroll () {
      let footerDom = document.querySelector('.iv-footer')
      this.initBottomScroll()
      this.$on('hook:beforeDestroy', () => {
        window.onscroll = null
        window.onresize = null
      })
      window.onscroll = () => {
        this.getPosition(footerDom)
      }
      window.onresize = () => {
        this.initBottomScroll()
        this.getPosition(footerDom)
      }
    },
    //获取最后学习信息
    getVideoInfo () {
      this.$ajax({
        url: 'api-course/portal/open/usercourse/getLastLearnInfo',
        method: 'get'
      }).then(res => {
        this.courseID = res.data.data.courseID
        this.courseName = res.data.data.courseName
      }).catch(() => {
        this.showInfo = false
      })
    },
    //关闭提示信息
    closeInfo () {
      this.showInfo = false
    },
    //跳转课程详情
    jumpDetail () {
      this.$router.push({
        path: '/course/course-detail',
        query: {
          courseID: this.courseID
        }
      })
    },
    //继续学习
    continueLearn () {
      this.pushPlay({
        courseId: this.courseID
      })
    },
    //app下载
    downApp () {

    },
    //帮助中心
    helpCenter () {

    },
    //关于我们
    aboutWe () {

    }
  },
  components: {
    Poptip,
    IconFont
  }
}
</script>
<style lang="scss">
.iv-footer {
  .iv-pop-width {
    color: rgba(0,0,0,0.65);
    .ivu-poptip-body {
      .ivu-poptip-body-content {
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../static/lib/css/base/variable.scss';
.iv-home-fixed {
  width: 100%;
  clear: both;
  background: rgba(0, 0, 0, 0.65);
  &.iv-fixed-bottom {
    position: fixed;
    bottom: 0;
  }
  .iv-home-tip {
    width: 1200px;
    padding: 0 12px;
    height: 48px;
    line-height: 48px !important;
    margin: 0 auto;
    color: #fff;
    text-align: center;
    .iv-home-tip-title {
      cursor: pointer;
    }
    .iv-home-tip-study {
      margin-left: 40px;
      cursor: pointer;
    }
    .iv-home-tip-title:hover, .iv-home-tip-study:hover, .iv-home-tip-close:hover {
      color: #1890FF;
    }
    .iv-home-tip-close {
      cursor: pointer;
    }
  }
}
.iv-footer {
  width: 100%;
  height: 70px;
  clear: both;
  background: #fff;
  line-height: 70px !important;
  box-shadow:0px -1px 4px 0px rgba(0,0,0,0.09);
  .iv-footer-content {
    width: 1176px;
    margin: 0 auto;
  }
  .iv-footer-right {
    ul {
      li {
        float: left;
        margin-right: 64px;
        cursor: pointer;
        img {
          width: 100px;
          height: 100px;
        }
      }
      li:hover {
        color: $iv-main-color;
      }
      li:last-child {
        margin-right: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/footer/index.vue